<app-sensor-history-toolbar [request]="request" [store]="store"></app-sensor-history-toolbar>
<ng-template *ngTemplateOutlet="templateRef; context : {$implicit: sensor, request: request, toolbar: store}"></ng-template>
